import { local_storage_keys } from "../constants/storage";
import { removeLocalStorageItem } from "./storage";

export const removeJwtToken = () => {
  removeLocalStorageItem(local_storage_keys.jwt_token);
};
